import { Lightbulb } from "lucide-react";
import type { Optimization } from "../lib/diagnostics";

interface Props {
  optimizations: Optimization[];
}

export function Optimizations({ optimizations }: Props) {
  return (
    <section className="mx-auto max-w-6xl px-6 py-8 lg:px-12">
      <div className="mb-5">
        <h3 className="flex items-center gap-2 text-lg font-bold text-foreground sm:text-xl">
          <Lightbulb className="h-5 w-5 text-warning" aria-hidden />
          Optimisations personnalisées
        </h3>
        <p className="mt-1 text-sm text-muted-foreground">
          {optimizations.length} pistes concrètes pour booster votre rentabilité
        </p>
      </div>
      <div className="grid gap-4 md:grid-cols-2">
        {optimizations.map((o) => {
          const IconCmp = o.icon;
          return (
            <article
              key={o.id}
              className="rounded-2xl border border-border bg-card p-5 shadow-sm transition hover:shadow-md"
            >
              <div className="flex items-start justify-between gap-3">
                <span className="inline-flex h-10 w-10 items-center justify-center rounded-xl bg-primary/10 text-primary">
                  <IconCmp className="h-5 w-5" aria-hidden />
                </span>
                <span className="rounded-full bg-success/10 px-2.5 py-0.5 text-xs font-semibold text-success">
                  {o.gainEstime}
                </span>
              </div>
              <h4 className="mt-3 font-bold text-foreground">{o.title}</h4>
              <p className="mt-1.5 text-sm leading-relaxed text-muted-foreground">{o.description}</p>
            </article>
          );
        })}
      </div>
    </section>
  );
}
